/**
 * Attach horizontal touch-swipe navigation to a carousel/slider root.
 *
 * Uses passive touch listeners and never calls preventDefault, so vertical page
 * scrolling is untouched. A gesture only counts as a swipe when horizontal
 * movement clears `threshold` and dominates the vertical movement.
 */
export interface SwipeHandlers {
    onNext: () => void;
    onPrev: () => void;
}

export function addSwipe(
    el: HTMLElement,
    { onNext, onPrev }: SwipeHandlers,
    threshold = 45
): void {
    let startX = 0;
    let startY = 0;
    let tracking = false;

    el.addEventListener('touchstart', (event) => {
        if (event.touches.length !== 1) {
            tracking = false;
            return;
        }
        startX = event.touches[0].clientX;
        startY = event.touches[0].clientY;
        tracking = true;
    }, { passive: true });

    el.addEventListener('touchend', (event) => {
        if (!tracking) return;
        tracking = false;

        const touch = event.changedTouches[0];
        if (!touch) return;

        const dx = touch.clientX - startX;
        const dy = touch.clientY - startY;

        if (Math.abs(dx) < threshold || Math.abs(dx) <= Math.abs(dy)) return;

        if (dx < 0) {
            onNext();
        } else {
            onPrev();
        }
    }, { passive: true });

    el.addEventListener('touchcancel', () => { tracking = false; }, { passive: true });
}
